<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-9 col-lg-12">
                                                <div class="row">

                                                    <div class="col-xl-8 col-xs-12 col-lg-8 col-md-8">
                                                        <div class="submit-field">
                                                            <h5>Nome </h5>
                                                            <input type="text" class="with-border" placeholder="Informe o nome aqui.." v-model="form.nome">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-2 col-xs-6 col-md-3">
                                                        <div class="submit-field">
                                                            <h5>Pontuação</h5>
                                                            <the-mask :mask="['#','##', '###', '####']"  type="tel" class="with-border" placeholder="0" v-model="form.pontos"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-12" v-if="form.imagem && form.imagem.indexOf('uploads/') != -1">
                                                        <div class="section-headline margin-top-0 margin-bottom-12">
                                                            <h5>Imagem atual</h5>
                                                        </div>                              
                                                        <img :src="$root.config.url + '/' + form.imagem" style="width: 200px; margin-bottom: 20px;">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="uploadButton">
                                                            <input class="uploadButton-input" type="file" name="imagem" @change="getBase64Imagem" accept="image/*" id="upload-imagem" />
                                                            <label class="uploadButton-button ripple-effect" for="upload-imagem">
                                                                <i class="material-icons">photo_library</i>&nbsp;&nbsp;Escolher foto
                                                            </label>
                                                            <span class="uploadButton-file-name" v-show="!form.imagem || form.imagem.indexOf('uploads/') != -1">Escolha a foto ilustrativa do prêmio</span>
                                                            <span class="uploadButton-file-name" v-show="form.imagem && form.imagem.indexOf('uploads/') == -1">Foto OK</span>
                                                        </div>
                                                    </div>

                                                    <!-- Button -->
                                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            {{ form.cod ? 'Salvar prêmio' : 'Cadastrar prêmio' }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarPremios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "cod":              "",
                "tipo":             "premio",
                "nome":             "",
                "pontos":           "",
                "imagem":           ""
            }            
        }
    },
    methods: {
        getBase64Imagem: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // console.log("result", result);
                        loading.hide();
                        self.form.imagem    = result;
                    });
                }); 
            }   
        },         
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/catalogo.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarPremios") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarPremios.vue